// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__VQ0wo","circle":"styles_circle__McY8K","profpic":"styles_profpic__bOWaL","small":"styles_small__qUH9p","large":"styles_large__OoIfx"};